<template>
  <parent>
    <div class="invalidations-form-wrapper popup-wrapper">
      <div class="popup">
        <div class="popup__header">
          <h6 class="bold">
            Create Invalidation
          </h6>
          <a
            class="ml-auto"
            @click="$emit('close')"
          ><GjIcon name="Close" /></a>
        </div>
        <div
          class="popup__body"
          :class="{ 'set-height': gettingInvalidation }"
        >
          <loading-page v-if="gettingInvalidation" />
          <template v-else>
            <b-form-group
              label="Distribution ID"
              label-for="distributionId"
              class="light"
            >
              <b-form-input
                id="distributionId"
                :value="distributionId"
                readonly
              />
            </b-form-group>
            <b-form-group
              label="Purge All"
              label-for="check-button"
              class="light pb-1"
            >
              <b-form-checkbox
                v-model="purgeAll"
                name="check-button"
                class="status-button"
                switch
                inline
                @change="onPurgeAllChange"
              />
            </b-form-group>
            <b-form-group
              label="Object Paths"
              label-for="invalidation"
              class="light mt-2"
            >
              <div class="position-relative">
                <b-form-textarea
                  id="invalidation"
                  ref="invalidation"
                  v-model="objectPaths"
                  :disabled="purgeAll"
                  class="mt-0"
                  :class="{ error: invalid }"
                  rows="6"
                />
                <div
                  v-if="objectPaths.length === 0"
                  class="invalidation-placeholder"
                  @click="invalidationFocus"
                >
                  Examples: <br>images/image1.jpg <br>/images/image1.jpg
                  <br>/images/ <br>/images/image
                </div>
              </div>
            </b-form-group>
          </template>
        </div>
        <div class="popup__footer">
          <button-loading
            variant="bg-primary"
            :spinning="addingInvalidation"
            @click="invalidate()"
          >
            Invalidate
          </button-loading>
        </div>
      </div>
    </div>
  </parent>
</template>
<script>
import redirectError from '@/services/redirectError'

export default {
  name: 'InvalidationFrom',
  props: {
    id: {
      type: String,
      default: null,
    },
    copy: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      objectPaths: '',
      invalid: false,
      purgeAll: false,
    }
  },
  computed: {
    distributionId() {
      return this.$route.params.id
    },
    invalidation() {
      return this.$store.state.cdn.invalidation
    },
    status() {
      const loc = this.invalidation.statusOptions.find(
        x => x.id === this.invalidation.statusId,
      )
      return loc.value
    },
    gettingInvalidation() {
      return this.$store.state.cdn.gettingInvalidation
    },
    addingInvalidation() {
      return this.$store.state.cdn.addingInvalidation
    },
  },
  watch: {
    objectPaths() {
      if (this.objectPaths.length > 0) {
        this.invalid = false
      }
    },
  },
  created() {
    if (this.copy) {
      this.$store
        .dispatch('cdn/getInvalidation', {
          distributionId: this.distributionId,
          id: this.id,
        })
        .then(() => {
          this.objectPaths = this.invalidation.objectPaths
        })
        .catch(err => redirectError(err, this.$router, this.$route.path))
    }
  },
  methods: {
    invalidate() {
      if (this.objectPaths.length > 0) {
        const res = this.objectPaths.split(' ')
        let domains = ''
        for (let i = 0; i < res.length; i++) {
          if (res[i].slice(-1) === ',') {
            res[i] = res[i].slice(0, -1)
          }
          if (i < res.length - 1) {
            res[i] += ', '
          }
          domains += res[i]
        }
        const query = {
          distributionId: this.distributionId,
          objectPaths: domains,
          priority: 3,
        }
        this.addInvalidation(query)
      } else {
        this.invalid = true
      }
    },
    addInvalidation(query) {
      this.$store
        .dispatch('cdn/addInvalidation', query)
        .then(() => {
          this.successToast('Invalidation was created')
          this.$emit('add')
        })
        .catch(error => {
          this.errorToast(
            error.response?.data?.errors[0] || 'Something went wrong',
          )
        })
    },
    invalidationFocus() {
      this.$refs.invalidation.focus()
    },
    onPurgeAllChange() {
      if (this.purgeAll) {
        this.objectPaths = '/*'
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.set-height {
  height: 180px;
  ::v-deep {
    div {
      padding: 0 !important;
      margin: 0 !important;
      height: 100%;
    }
  }
}
.invalidation-placeholder {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding: 0.5rem 1rem;
  opacity: 0.5;
}
</style>
